import { ReactNode } from "react"
import { Logo } from "../logo/Logo"
import { H1 } from "../typography/titles/Titles"
import { NavLink } from "react-router-dom"
import style from "./FirstScreen.module.scss"

const { firstScreen, wrapper, container, about, title, yellow, stevens, form, logo } = style

type Props = {
	children: ReactNode
}

export const FirstScreen = ({ children }: Props) => {
	return (
		<main className={firstScreen}>
			<div className={wrapper}>
				<div className={container}>
					<NavLink to="/">
						<Logo className={logo} />
					</NavLink>
					<div className={form}>{children}</div>
				</div>
				<div className={about}>
					<span className={stevens}>Archiscan</span>
					<H1 className={title}>
						Find architectural cabinets <span className={yellow}>with ease</span>
					</H1>
				</div>
			</div>
		</main>
	)
}
